// Threshold at which `formatMoney` rounds to "$0.00" — values below this in
// magnitude display as zero and shouldn't be tone-colored as gain/loss.
const GAIN_LOSS_ZERO_EPSILON = 0.005

// Tailwind text-color class that shades a monetary gain/loss value: green for
// gains, red for losses, and no tone for (near-)zero or non-finite values.
// Shared across the account-details summary surfaces (Summary tab, Holdings
// tab, sleeve metrics) so the same Unrealized G/L number renders identically
// wherever it appears.
export function getGainLossClass(value: number | null): string | undefined {
  if (value == null || !Number.isFinite(value)) return undefined
  if (Math.abs(value) < GAIN_LOSS_ZERO_EPSILON) return undefined
  return value > 0 ? 'text-text-success' : 'text-text-danger'
}
